<template>
  <div class="header-box">
    <div class="item hover">
      <svg
        t="1776150227633"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="5501"
        width="28"
        height="28"
      >
        <path
          d="M256 0v409.6h512V0h256v1024H768V665.6H256V1024H0V0z"
          fill="var(--el-color-font)"
          p-id="5502"
        ></path>
      </svg>
    </div>
    <el-popover placement="bottom" width="100%" trigger="click">
      <template #reference>
        <div class="item hover">
          <svg
            t="1776150414476"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6738"
            width="24"
            height="24"
          >
            <path
              d="M192.037 287.953h640.124c17.673 0 32-14.327 32-32s-14.327-32-32-32H192.037c-17.673 0-32 14.327-32 32s14.327 32 32 32zM192.028 543.17h638.608c17.673 0 32-14.327 32-32s-14.327-32-32-32H192.028c-17.673 0-32 14.327-32 32s14.327 32 32 32zM832.161 735.802H192.037c-17.673 0-32 14.327-32 32s14.327 32 32 32h640.124c17.673 0 32-14.327 32-32s-14.327-32-32-32z"
              fill="var(--el-color-font)"
              p-id="6739"
            ></path>
          </svg>
        </div>
      </template>
      <div class="flex gap-x-14 menu-box">
        <div
          class="flex flex-col text-xs gap-y-3 items-center justify-center"
          style="color: var(--el-color-danger); width: 10px"
        >
          <el-icon><StarFilled /></el-icon>
          右键加收藏
        </div>
        <div v-for="menu in state.menus" :key="menu">
          <div class="text-center font-bold">{{ menu.name }}</div>
          <div class="grid grid-cols-2 gap-1 mt-3 text-sm">
            <div
              v-for="child in menu.children"
              :key="child"
              class="p-2 text-xs rounded cursor-pointer w-22 flex gap-x-1 items-center justify-start"
              :class="
                $store.state.nav_id == child.id
                  ? 'justify-center'
                  : 'hover:text-primary'
              "
              @click="
                $store.commit('openMenu', {
                  id: child.id,
                  path: child.path,
                  title: child.name,
                })
              "
              @contextmenu.prevent="onColletMenu($event, child)"
            >
              <div class="w-3 flex">
                <el-icon
                  v-if="state.collet_menuids.includes(child.id)"
                  color="var(--el-color-danger)"
                  ><StarFilled
                /></el-icon>
              </div>
              {{ child.name }}
            </div>
          </div>
        </div>
      </div>
    </el-popover>
    <div class="item hover">
      <svg
        t="1776150503069"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="7888"
        width="24"
        height="24"
      >
        <path
          d="M447.325002 129.919978c-178.868807 0-323.872319 145.003512-323.872319 323.874365s145.003512 323.874365 323.872319 323.874365c178.870854 0 323.874365-145.003512 323.874365-323.874365S626.195855 129.919978 447.325002 129.919978zM447.325002 713.712071c-143.31915 0-259.915681-116.598578-259.915681-259.917728s116.596532-259.917728 259.915681-259.917728 259.917728 116.598578 259.917728 259.917728S590.643128 713.712071 447.325002 713.712071z"
          fill="var(--el-color-font)"
          p-id="7889"
        ></path>
        <path
          d="M891.573945 840.061734 748.236376 696.699606c-13.43601 16.625656-28.371164 31.91385-44.338834 46.099944l142.458549 142.481062c6.246261 6.246261 14.427594 9.368368 22.60995 9.368368s16.363689-3.123131 22.60995-9.368368C904.065444 872.789113 904.065444 852.553233 891.573945 840.061734z"
          fill="var(--el-color-font)"
          p-id="7890"
        ></path>
      </svg>
    </div>
    <div class="item hover">
      <svg
        t="1776150529001"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="9013"
        width="24"
        height="24"
      >
        <path
          d="M856.798419 793.112446l-73.742515-129.741923L783.055904 401.843134c0-100.20112-75.31636-208.644971-185.111998-248.378927-5.348821-53.104475-40.835034-91.831498-87.334068-91.831498-46.434565 0-82.048691 38.728046-87.332021 91.831498-109.73424 39.733956-185.049576 148.176784-185.049576 248.378927l0 261.527388-77.329203 136.096654c-5.158487 8.997931-5.03262 20.008706 0.125867 28.944216 5.15951 8.933463 14.724353 14.346753 25.042349 14.346753l184.04162 0c13.528108 65.310472 71.353095 114.51308 140.501988 114.51308 69.213361 0 127.036301-49.202609 140.500964-114.51308l184.04162 0c0.505513 0 0.881067 0 1.322112 0 16.045441 0 29.007661-12.898775 29.007661-28.944216C865.482195 805.697065 862.209662 798.335401 856.798419 793.112446M510.609839 119.708406c10.444886 0 18.875906 7.927553 24.287149 19.756973-8.05342-0.818645-15.85613-2.705622-24.287149-2.705622s-16.232706 1.886977-24.287149 2.705622C491.734956 127.634936 500.165975 119.708406 510.609839 119.708406M510.609839 899.258974c-36.808324 0-67.576071-23.657816-79.532381-56.500828l159.062715 0C578.186933 875.600135 547.482631 899.258974 510.609839 899.258974M235.90022 784.807293l56.502875-99.476619c2.515287-4.28049 3.89982-9.314133 3.89982-14.34573L296.302915 401.843134c0-97.747231 91.611487-207.070102 214.306924-207.070102 122.694413 0 214.431767 109.322871 214.431767 207.070102L725.041606 670.984944c0 5.031597 1.322112 10.06524 3.774977 14.34573l56.565297 99.476619L235.90022 784.807293z"
          fill="var(--el-color-font)"
          p-id="9014"
        ></path>
      </svg>
    </div>
    <div class="overflow-hidden flex items-center px-10 justify-center">
      <transition-group
        class="flex items-center px-10 justify-center"
        name="list"
        tag="div"
      >
        <div
          class="flex items-center overflow-x-auto select-menu gap-x-2"
          ref="menu_dom"
        >
          <div
            class="flex items-center gap-x-1 hover p-2 rounded cursor-pointer flex-shrink-0"
            v-for="item in state.collet_menus"
            :key="item"
            @click="
              $store.commit('openMenu', {
                id: item.id,
                path: item.path,
                title: item.name,
              })
            "
            :draggable="true"
            @dragstart="dragstart(item)"
            @dragenter="dragenter(item, $event)"
            @dragend="getDragend"
          >
            <svg
              class="cursor-pointer"
              viewBox="0 0 1024 1024"
              width="12"
              height="12"
            >
              <template v-if="item.icons">
                <path
                  v-for="icon in item.icons"
                  :key="icon"
                  :d="icon"
                  fill="var(--el-color-font)"
                ></path>
              </template>
              <path
                v-else
                :d="state.default_svg"
                fill="var(--el-color-font)"
              ></path>
            </svg>
            <text style="color: var(--el-color-font)" class="text-sm">
              {{ item.name }}
            </text>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="flex items-center justify-center">
      <el-popover placement="left" width="auto">
        <template #reference>
          <svg
            class="cursor-pointer"
            viewBox="0 0 1024 1024"
            width="22"
            height="22"
            title="自定义主题颜色"
          >
            <path
              d="M533.333333 853.333333c179.2 0 320-145.066667 320-320S708.266667 213.333333 533.333333 213.333333 213.333333 358.4 213.333333 533.333333c0 93.866667 34.133333 132.266667 115.2 157.866667 8.533333 4.266667 12.8 4.266667 21.333334 8.533333 4.266667 0 21.333333 4.266667 21.333333 8.533334 51.2 17.066667 76.8 25.6 98.133333 51.2 17.066667 17.066667 29.866667 38.4 42.666667 59.733333 4.266667 8.533333 8.533333 17.066667 8.533333 21.333333 8.533333 0 8.533333 8.533333 12.8 12.8z m0 42.666667c-59.733333 0-21.333333-42.666667-89.6-110.933333-64-64-273.066667-25.6-273.066666-251.733334C170.666667 332.8 332.8 170.666667 533.333333 170.666667S896 332.8 896 533.333333 733.866667 896 533.333333 896z m72.533334-106.666667c-42.666667 0-76.8-34.133333-76.8-76.8s34.133333-72.533333 76.8-72.533333 76.8 34.133333 76.8 72.533333-34.133333 76.8-76.8 76.8z m0-42.666666c17.066667 0 34.133333-12.8 34.133333-34.133334s-12.8-29.866667-34.133333-29.866666-34.133333 12.8-34.133334 29.866666 17.066667 34.133333 34.133334 34.133334zM640 384c-25.6 0-42.666667-17.066667-42.666667-42.666667s17.066667-42.666667 42.666667-42.666666 42.666667 17.066667 42.666667 42.666666-17.066667 42.666667-42.666667 42.666667z m-119.466667-34.133333c-25.6 0-42.666667-17.066667-42.666666-42.666667s17.066667-42.666667 42.666666-42.666667 42.666667 17.066667 42.666667 42.666667-17.066667 42.666667-42.666667 42.666667zM725.333333 469.333333c-25.6 0-42.666667-17.066667-42.666666-42.666666s17.066667-42.666667 42.666666-42.666667 42.666667 17.066667 42.666667 42.666667-17.066667 42.666667-42.666667 42.666666zM405.333333 384c-25.6 0-42.666667-17.066667-42.666666-42.666667s17.066667-42.666667 42.666666-42.666666 42.666667 17.066667 42.666667 42.666666-17.066667 42.666667-42.666667 42.666667z"
              fill="var(--el-color-font)"
            ></path>
          </svg>
        </template>
        <div class="relative">
          <el-color-picker-panel
            v-model="state.color"
            :predefine="[
              '#ff4500',
              '#ff8c00',
              '#ffd700',
              '#90ee90',
              '#00ced1',
              '#1e90ff',
              '#c71585',
              'rgba(255, 69, 0, 0.68)',
              'rgb(255, 120, 0)',
              'hsv(51, 100, 98)',
              'hsva(120, 40, 94, 0.5)',
              'hsl(181, 100%, 37%)',
              'hsla(209, 100%, 56%, 0.73)',
              '#c7158577',
            ]"
          />
          <el-button
            @click="onSetTheme"
            plain
            class="absolute"
            style="right: 10px; bottom: 10px"
            >确定
          </el-button>
        </div>
      </el-popover>
      <el-popover placement="bottom" width="auto">
        <template #reference>
          <strong
            style="
              font-size: 18px;
              color: var(--el-color-font);
              margin-left: 10px;
              cursor: pointer;
            "
            title="自定义字体颜色"
          >
            A
          </strong>
        </template>
        <div class="relative">
          <el-color-picker-panel
            v-model="state.fontColor"
            :predefine="[
              '#ff4500',
              '#ff8c00',
              '#ffd700',
              '#90ee90',
              '#00ced1',
              '#1e90ff',
              '#c71585',
              'rgba(255, 69, 0, 0.68)',
              'rgb(255, 120, 0)',
              'hsv(51, 100, 98)',
              'hsva(120, 40, 94, 0.5)',
              'hsl(181, 100%, 37%)',
              'hsla(209, 100%, 56%, 0.73)',
              '#c7158577',
            ]"
          />
          <el-button
            @click="onSetColor"
            plain
            class="absolute"
            style="right: 10px; bottom: 10px"
            >确定
          </el-button>
        </div>
      </el-popover>
    </div>
    <el-dropdown class="h-full">
      <div
        class="item hover flex items-center outline-none h-full gap-x-1 whitespace-nowrap px-2"
        style="color: var(--el-color-font)"
      >
        <el-icon color="var(--el-color-font)"><User /></el-icon>
        <text class="">{{ $store.state.loginUser?.name }}</text>
        <text class="text-xs" style="color: var(--el-color-font)">{{
          $store.state.loginUser?.department_name
        }}</text>
      </div>
      <template #dropdown>
        <el-dropdown-menu style="--el-dropdown-menuItem-hover-fill: #f6f6f6">
          <el-dropdown-item
            icon="user"
            @click="
              $store.commit('openMenu', {
                path: 'HomeEditInfo',
                title: '个人信息',
                refresh: true,
              })
            "
            >个人信息</el-dropdown-item
          >
          <el-dropdown-item
            style="color: #f00"
            icon="lock"
            @click="
              $store.commit('openMenu', {
                path: 'HomeEditPass',
                title: '修改密码',
                refresh: true,
              })
            "
            >修改密码
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <div class="item hover" @click="onLogout">
      <svg
        t="1776151515824"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="10070"
        width="24"
        height="24"
      >
        <path
          d="M662.016 247.6544a32 32 0 1 1 29.4912-56.832 390.4 390.4 0 1 1-359.0144 0 32 32 0 1 1 29.4912 56.832 326.4 326.4 0 1 0 300.032 0zM544 384a32 32 0 1 1-64 0v-256a32 32 0 1 1 64 0v256z"
          fill="var(--el-color-font)"
          p-id="10071"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { setThemeColor, setFontColor } from "@/utils/theme";
import { ElMessageBox, ElLoading } from "element-plus";
import { useRouter } from "vue-router";
export default {
  setup() {
    const router = useRouter();
    const menu_dom = ref(null);
    const state = reactive({
      menus: [
        {
          name: "项目管理",
          children: [
            {
              id: 1,
              name: "甲方管理",
              path: "JieSuanDanWeiList",
              icons: [
                "M490.453333 635.456c-9.386667-7.573333-15.04-17.066667-15.04-30.336 0-20.864 16.896-37.930667 37.546667-37.930667 20.672 0 37.546667 17.066667 37.546667 37.930667 0 13.269333-5.610667 22.762667-14.997334 30.336l50.688 180.16c3.754667 13.269333 0 26.538667-9.386666 36.010667l-50.688 51.2a18.026667 18.026667 0 0 1-26.304 0l-50.688-51.2c-9.386667-9.472-13.141333-22.741333-9.386667-36.010667l50.688-180.16z m-142.634666-161.386667c-60.394667-49.28-100.032-123.242667-100.032-208.597333C247.786667 119.466667 366.677333 0 512 0c145.301333 0 264.213333 119.466667 264.213333 265.472 0 83.456-39.637333 159.296-100.032 208.597333C864.896 529.066667 1002.666667 703.530667 1002.666667 910.229333 1002.666667 972.8 951.701333 1024 889.429333 1024H134.570667C72.277333 1024 21.333333 972.8 21.333333 910.229333c0-206.72 137.770667-381.162667 326.485334-436.16z m165.973333-6.442666a202.666667 202.666667 0 1 0 0-405.333334 202.666667 202.666667 0 0 0 0 405.333334zM899.882667 960c21.333333 0 38.784-18.346667 38.784-40.746667C938.666667 695.296 764.117333 512 550.784 512h-77.568C259.882667 512 85.333333 695.274667 85.333333 919.253333 85.333333 941.653333 102.784 960 124.117333 960h775.765334z",
              ],
            },
            {
              id: 2,
              name: "会议管理",
              path: "HuiYiList",
              icons: [
                "M678.613 872.747H368.427a65.493 65.493 0 0 1-65.494-65.494v-8.106a220.587 220.587 0 0 1 440.96 0v8.106a65.28 65.28 0 0 1-65.28 65.494zM537.6 547.84a128 128 0 1 1 0-256 128 128 0 0 1 0 256z m-252.373-5.76a85.333 85.333 0 1 1 85.333-85.333 85.333 85.333 0 0 1-85.333 85.333z m109.653 30.507A205.227 205.227 0 0 0 257.92 766.08v7.68a60.8 60.8 0 0 0 60.8 60.8H181.76a61.013 61.013 0 0 1-61.013-60.8v-7.68A205.653 205.653 0 0 1 326.4 560.64a202.88 202.88 0 0 1 68.48 11.947z m284.373-115.84a85.333 85.333 0 1 1 85.334 85.333 85.333 85.333 0 0 1-85.334-85.333z m-22.613 115.84a202.88 202.88 0 0 1 68.693-11.947 205.44 205.44 0 0 1 205.44 205.44v7.68a61.013 61.013 0 0 1-61.013 60.8H732.8a60.8 60.8 0 0 0 60.8-60.8v-7.68a205.013 205.013 0 0 0-136.96-193.493z",
              ],
            },
            {
              id: 3,
              name: "会务服务",
              path: "HuiWuList",
              icons: [
                "M640 742.4V853.333333h-85.333333v-174.933333c106.666667-17.066667 192-102.4 209.066666-209.066667h85.333334c-12.8 123.733333-98.133333 230.4-209.066667 273.066667z m-256 0c-115.2-42.666667-196.266667-149.333333-213.333333-273.066667h85.333333c17.066667 106.666667 102.4 192 209.066667 209.066667V853.333333H384v-110.933333zM605.866667 213.333333C674.133333 213.333333 725.333333 260.266667 725.333333 332.8c0 59.733333-51.2 123.733333-89.6 157.866667-25.6 25.6-68.266667 51.2-123.733333 81.066666-55.466667-29.866667-98.133333-55.466667-123.733333-81.066666-42.666667-38.4-89.6-98.133333-89.6-157.866667C298.666667 260.266667 349.866667 213.333333 418.133333 213.333333c38.4 0 68.266667 17.066667 93.866667 46.933334 25.6-29.866667 55.466667-46.933333 93.866667-46.933334z",
              ],
            },
            { id: 4, name: "报名审核" },
            { id: 5, name: "会议日志" },
            {
              id: 30,
              name: "乙方管理",
              path: "BaoZhangDanWeiList",
              icons: [
                "M860.842667 877.226667H822.613333V537.6c0-46.421333-29.696-87.04-74.069333-101.205333l-149.162667-47.274667v-114.858667c0-54.613333-44.373333-98.986667-98.986666-98.986666H263.850667c-54.613333 0-98.986667 44.373333-98.986667 98.986666V877.226667H112.981333c-18.773333 0-34.133333 15.36-34.133333 34.133333s15.36 34.133333 34.133333 34.133333h747.861334c18.773333 0 34.133333-15.36 34.133333-34.133333s-15.36-34.133333-34.133333-34.133333z m-627.712 0V274.261333c0-16.896 13.824-30.72 30.72-30.72h236.714666c16.896 0 30.72 13.824 30.72 30.72V877.226667H233.130667z m366.250666 0V460.8l128.512 40.789333c15.872 4.949333 26.453333 19.456 26.453334 36.181334v339.626666h-154.965334z",
              ],
            },
          ],
        },
        {
          name: "供应链",
          children: [
            {
              id: 6,
              name: "供应商",
              path: "GongYingShangList",
              icons: [
                "M898.3 462.2c0-213-173.3-386.3-386.3-386.3S125.7 249.2 125.7 462.2c0 119.9 54.9 227.3 141 298.2v168.9c0 5.5 3.2 10.4 8.1 12.7 1.9 0.9 4 1.3 6 1.3 3.2 0 6.4-1.1 9-3.2l125.4-103.9c31 8 63.4 12.3 96.8 12.3 29.4 0 58-3.3 85.5-9.6l127.8 105.9c2.6 2.1 5.8 3.2 9 3.2 2 0 4.1-0.4 6-1.3 4.9-2.3 8.1-7.3 8.1-12.7V767.5c91.1-70.7 149.9-181.3 149.9-305.3zM294.8 899.4V781.5c27.1 18.5 56.7 33.6 88.1 44.8l-88.1 73.1z m425.4 4.6l-89.5-74.2c31.8-10.3 61.9-24.6 89.5-42.4V904z m11.3-171c-4.4 0.9-8 3.8-9.9 7.7-58.4 44-131 70.2-209.6 70.2-192.3 0-348.7-156.5-348.7-348.7S319.7 113.5 512 113.5c192.3 0 348.7 156.5 348.7 348.7 0 109.2-50.4 206.9-129.2 270.8z",
                "M617.8 413.2h55.4V384h-55.4v-87.2h-30.5V384h-74.6v-87.2h-30.9V384H428v29.2h53.8v97.6h-65.5v28.8H685v-28.8h-67.1v-97.6z m-30.4 97.6h-74.6v-97.6h74.6v97.6zM397.6 291.9c-20.9 65.3-53.9 123.3-99.3 173.9l10 31.7c15.6-16.1 30.7-33.9 45.5-53.4v233.6h30.9V397c16.7-28.6 30.4-59.4 41.3-92.2l-28.4-12.9zM575.3 570c33.4 39.8 59.5 75.2 78.4 106.3l26.7-18.3c-19.7-30.9-46.6-65.2-80.5-103l-24.6 15zM418.9 658.4l25.9 18.8c30-30.3 55.7-65.7 77.2-106.3L494.5 558c-20.4 38.3-45.6 71.8-75.6 100.4z",
              ],
            },
            { id: 7, name: "采购管理" },
            { id: 8, name: "付款申请" },
            {
              id: 9,
              name: "酒店库",
              path: "JiuDianList",
              icons: [
                "M896 896h42.666667v42.666667H85.333333v-42.666667h42.666667V170.730667A42.666667 42.666667 0 0 1 170.602667 128h469.461333C663.594667 128 682.666667 147.242667 682.666667 170.730667V896h170.666666V426.666667h-128v-42.666667h149.333334a21.333333 21.333333 0 0 1 21.333333 21.333333v490.666667z m-256 0V170.730667L170.602667 170.666667 170.666667 896h469.333333zM277.333333 298.666667h256v42.666666H277.333333v-42.666666z m0 256h256v42.666666H277.333333v-42.666666z m0-128h256v42.666666H277.333333v-42.666666z m0 256h256v42.666666H277.333333v-42.666666z",
              ],
            },
            {
              id: 10,
              name: "人员管理",
              path: "RenYuanList",
              icons: [
                "M790.528 477.12c57.024-48.96 93.824-124.8 93.824-209.984C884.352 119.808 774.784 0 640 0S395.648 119.808 395.648 267.136c0 85.184 36.8 161.024 93.824 209.984C339.2 542.72 232.704 703.104 232.704 890.432v89.024c0 24.64 18.24 44.544 40.768 44.544h733.056c22.528 0 40.768-19.904 40.768-44.544v-89.024c0-187.328-106.56-347.712-256.768-413.312zM640 89.024c89.856 0 162.88 79.872 162.88 178.112S729.856 445.248 640 445.248 477.12 365.376 477.12 267.136 550.144 88.96 640 88.96z m325.76 845.952H314.24v-44.544c0-196.416 146.112-356.16 325.76-356.16 179.712 0 325.76 159.744 325.76 356.16v44.544z",
                "M316.352 542.528c1.216-2.88 1.216-5.888 1.792-8.832 0.448-1.792 0.896-3.52 1.088-5.44a49.408 49.408 0 0 0-0.32-10.88c-0.192-1.92 0.256-3.776-0.192-5.76-0.256-1.024-0.96-1.856-1.28-2.944-0.64-2.112-1.536-4.032-2.496-5.952a46.784 46.784 0 0 0-6.4-11.008c-0.384-0.512-0.832-0.832-1.28-1.28a41.792 41.792 0 0 0-13.568-10.24c-46.912-22.784-77.184-73.472-77.184-129.28 0-65.6 40.896-122.176 99.392-137.472 23.296-6.144 37.568-31.616 32-56.96-5.696-25.28-29.184-40.64-52.288-34.752-97.6 25.6-165.76 119.872-165.76 229.248 0 59.648 20.928 115.584 56.32 158.08C73.6 572.736 0 699.84 0 843.776v72.96c0 25.984 19.392 47.104 43.328 47.104 23.936 0 43.264-21.12 43.264-47.168v-72.96c0-130.368 80.512-242.24 196.096-273.92a43.392 43.392 0 0 0 33.664-27.2zM1091.456 508.48c35.84-42.624 56.96-98.624 56.96-158.4 0-106.624-66.688-200.32-162.24-227.968-23.36-6.784-47.36 8.128-53.76 33.28-6.272 25.216 7.616 51.136 30.976 57.92 57.28 16.512 97.28 72.832 97.28 136.768 0 55.872-30.528 106.496-77.952 129.344a43.008 43.008 0 0 0-14.016 10.496c-0.32 0.384-0.768 0.64-1.088 1.088a46.912 46.912 0 0 0-6.592 11.136c-0.896 1.984-1.92 3.84-2.56 5.888-0.256 1.088-0.96 1.92-1.28 3.008-0.384 1.92 0 3.84-0.128 5.76a49.344 49.344 0 0 0-0.32 10.88c0.192 1.92 0.64 3.584 1.088 5.376 0.64 3.008 0.64 6.016 1.792 8.896 6.4 15.552 19.584 25.088 34.112 27.264 117.056 31.744 198.592 143.744 198.592 274.304v73.024c0 26.112 19.584 47.232 43.84 47.232 24.256 0 43.84-21.12 43.84-47.232v-72.96c0-144.128-74.432-271.424-188.544-335.104z",
              ],
            },
            {
              id: 31,
              name: "成本库",
              path: "ChengBenKuList",
              icons: [
                "M790.528 477.12c57.024-48.96 93.824-124.8 93.824-209.984C884.352 119.808 774.784 0 640 0S395.648 119.808 395.648 267.136c0 85.184 36.8 161.024 93.824 209.984C339.2 542.72 232.704 703.104 232.704 890.432v89.024c0 24.64 18.24 44.544 40.768 44.544h733.056c22.528 0 40.768-19.904 40.768-44.544v-89.024c0-187.328-106.56-347.712-256.768-413.312zM640 89.024c89.856 0 162.88 79.872 162.88 178.112S729.856 445.248 640 445.248 477.12 365.376 477.12 267.136 550.144 88.96 640 88.96z m325.76 845.952H314.24v-44.544c0-196.416 146.112-356.16 325.76-356.16 179.712 0 325.76 159.744 325.76 356.16v44.544z",
                "M316.352 542.528c1.216-2.88 1.216-5.888 1.792-8.832 0.448-1.792 0.896-3.52 1.088-5.44a49.408 49.408 0 0 0-0.32-10.88c-0.192-1.92 0.256-3.776-0.192-5.76-0.256-1.024-0.96-1.856-1.28-2.944-0.64-2.112-1.536-4.032-2.496-5.952a46.784 46.784 0 0 0-6.4-11.008c-0.384-0.512-0.832-0.832-1.28-1.28a41.792 41.792 0 0 0-13.568-10.24c-46.912-22.784-77.184-73.472-77.184-129.28 0-65.6 40.896-122.176 99.392-137.472 23.296-6.144 37.568-31.616 32-56.96-5.696-25.28-29.184-40.64-52.288-34.752-97.6 25.6-165.76 119.872-165.76 229.248 0 59.648 20.928 115.584 56.32 158.08C73.6 572.736 0 699.84 0 843.776v72.96c0 25.984 19.392 47.104 43.328 47.104 23.936 0 43.264-21.12 43.264-47.168v-72.96c0-130.368 80.512-242.24 196.096-273.92a43.392 43.392 0 0 0 33.664-27.2zM1091.456 508.48c35.84-42.624 56.96-98.624 56.96-158.4 0-106.624-66.688-200.32-162.24-227.968-23.36-6.784-47.36 8.128-53.76 33.28-6.272 25.216 7.616 51.136 30.976 57.92 57.28 16.512 97.28 72.832 97.28 136.768 0 55.872-30.528 106.496-77.952 129.344a43.008 43.008 0 0 0-14.016 10.496c-0.32 0.384-0.768 0.64-1.088 1.088a46.912 46.912 0 0 0-6.592 11.136c-0.896 1.984-1.92 3.84-2.56 5.888-0.256 1.088-0.96 1.92-1.28 3.008-0.384 1.92 0 3.84-0.128 5.76a49.344 49.344 0 0 0-0.32 10.88c0.192 1.92 0.64 3.584 1.088 5.376 0.64 3.008 0.64 6.016 1.792 8.896 6.4 15.552 19.584 25.088 34.112 27.264 117.056 31.744 198.592 143.744 198.592 274.304v73.024c0 26.112 19.584 47.232 43.84 47.232 24.256 0 43.84-21.12 43.84-47.232v-72.96c0-144.128-74.432-271.424-188.544-335.104z",
              ],
            },
          ],
        },
        {
          name: "业务审批",
          children: [
            { id: 12, name: "付款审批", path: "FuKuanShenPiList" },
            { id: 13, name: "费用审批", path: "FeiYongShenPiList" },
            { id: 14, name: "核算审批", path: "HeSuanShenPiList" },
            { id: 33, name: "发票审批", path: "FaPiaoShenPiList" },
          ],
        },
        {
          name: "财务管理",
          children: [
            { id: 32, name: "银行账户", path: "ZhangHuList" },
            { id: 15, name: "到款管理", path: "DaoKuanList" },
            { id: 16, name: "账单收款", path: "ZhangDanShouKuanList" },
            // { id: 17, name: "应收账款", path: "YingShouZhangKuanList" },
            // { id: 18, name: "应付账款", path: "YingFuZhangKuanList" },
            { id: 19, name: "付款操作", path: "FuKuanList" },
            { id: 34, name: "发票管理", path: "FaPiaoList" },
          ],
        },
        {
          name: "数据分析",
          children: [
            { id: 20, name: "统计报表" },
            { id: 21, name: "业绩核算" },
          ],
        },
        {
          name: "行政管理",
          children: [
            { id: 22, name: "公告管理" },
            { id: 23, name: "通知公告" },
            { id: 24, name: "办公费用", path: "BanGongFeiYongList" },
          ],
        },
        {
          name: "系统管理",
          children: [
            { id: 25, name: "用户管理", path: "YongHuList" },
            { id: 26, name: "角色管理", path: "JueSeList" },
            { id: 27, name: "图片库", path: "TuPianKuList" },
            { id: 28, name: "数据字典", path: "ZiDianList" },
            { id: 29, name: "系统配置", path: "XiTongIndex" },
          ],
        },
      ],
      default_svg:
        "M490.453333 635.456c-9.386667-7.573333-15.04-17.066667-15.04-30.336 0-20.864 16.896-37.930667 37.546667-37.930667 20.672 0 37.546667 17.066667 37.546667 37.930667 0 13.269333-5.610667 22.762667-14.997334 30.336l50.688 180.16c3.754667 13.269333 0 26.538667-9.386666 36.010667l-50.688 51.2a18.026667 18.026667 0 0 1-26.304 0l-50.688-51.2c-9.386667-9.472-13.141333-22.741333-9.386667-36.010667l50.688-180.16z m-142.634666-161.386667c-60.394667-49.28-100.032-123.242667-100.032-208.597333C247.786667 119.466667 366.677333 0 512 0c145.301333 0 264.213333 119.466667 264.213333 265.472 0 83.456-39.637333 159.296-100.032 208.597333C864.896 529.066667 1002.666667 703.530667 1002.666667 910.229333 1002.666667 972.8 951.701333 1024 889.429333 1024H134.570667C72.277333 1024 21.333333 972.8 21.333333 910.229333c0-206.72 137.770667-381.162667 326.485334-436.16z m165.973333-6.442666a202.666667 202.666667 0 1 0 0-405.333334 202.666667 202.666667 0 0 0 0 405.333334zM899.882667 960c21.333333 0 38.784-18.346667 38.784-40.746667C938.666667 695.296 764.117333 512 550.784 512h-77.568C259.882667 512 85.333333 695.274667 85.333333 919.253333 85.333333 941.653333 102.784 960 124.117333 960h775.765334z",
      collet_menuids: [], //已选择的菜单Id集合
      collet_menus: [], //已选择的菜单集合
    });
    onMounted(() => {
      state.color = localStorage.getItem("primary-theme-color");

      menu_dom.value.addEventListener("wheel", (e) => {
        e.preventDefault(); // 阻止默认垂直滚动
        menu_dom.value.scrollLeft += e.deltaY; // 滚轮上下 → 控制左右
      });

      let menuids = localStorage.getItem("collet_menuids");
      if (!menuids) {
        menuids = "2,3,1,9,10,6";
      }

      state.collet_menuids = menuids.split(",").map((m) => parseInt(m));
      state.collet_menus = [];
      let collet_menus = [];
      state.menus.forEach((menu) => {
        menu.children.forEach((child) => {
          if (state.collet_menuids.includes(child.id)) collet_menus.push(child);
        });
      });

      state.collet_menuids.forEach((e) => {
        state.collet_menus.push(collet_menus.find((m) => m.id == e));
      });
    });

    //设置主题
    const onSetTheme = () => {
      setThemeColor(state.color, (res) => {
        state.fontColor = res;
      });
    };

    //设置主题
    const onSetColor = () => {
      setFontColor(state.fontColor);
    };

    const onColletMenu = (e, item) => {
      // 阻止浏览器默认菜单
      e.preventDefault();

      if (state.collet_menuids.includes(item.id)) {
        state.collet_menuids = state.collet_menuids.filter((w) => w != item.id);
        state.collet_menus = state.collet_menus.filter((w) => w.id != item.id);
      } else {
        state.collet_menuids.push(item.id);
        state.collet_menus.push(item);
      }
      localStorage.setItem("collet_menuids", state.collet_menuids.join(","));
    };

    const dragstart = (value) => {
      state.oldData = value;
      state.dragStartId = value;
    };
    const dragenter = (value) => {
      state.newData = value;
      state.dragEndId = value;
    };
    const getDragend = () => {
      if (state.oldData !== state.newData) {
        let oldIndex = state.collet_menus.indexOf(state.oldData);
        let newIndex = state.collet_menus.indexOf(state.newData);
        let newItems = [...state.collet_menus];
        // 删除之前DOM节点
        newItems.splice(oldIndex, 1);
        // 在拖拽结束目标位置增加新的DOM节点
        newItems.splice(newIndex, 0, state.oldData);
        // 每次拖拽结束后，将拖拽处理完成的数据，赋值原数组，使DOM视图更新，页面显示拖拽动画
        state.collet_menus = newItems;

        localStorage.setItem(
          "collet_menuids",
          newItems.map((m) => m.id).join(","),
        );
        // 每次拖拽结束后调用接口时时保存数据
      }
    };

    const onLogout = () => {
      ElMessageBox.confirm(`您确定退出登录吗？`, "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const loading = ElLoading.service({
          lock: true,
          text: "正在退出……",
          background: "rgba(0, 0, 0, 0.7)",
        });
        setTimeout(() => {
          localStorage.removeItem("token");
          router.go(0);
          loading.close();
        }, 1000);
      });
    };

    return {
      state,
      onSetTheme,
      onSetColor,
      menu_dom,
      onColletMenu,
      dragstart,
      dragenter,
      getDragend,
      onLogout,
    };
  },
};
</script>

<style lang="scss" scoped>
.header-box {
  height: 64px;
  display: grid;
  grid-template-columns: repeat(4, 64px) 1fr 100px auto 64px;
  background-color: var(--el-color-primary);

  .item {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hover {
    &:hover {
      background-color: var(--el-color-primary-light-3);
    }
  }
}

.menu-box {
  .active {
    background-color: var(--el-color-primary-light-3);
    color: var(--el-color-font);
  }
}

.select-menu::-webkit-scrollbar {
  display: none;
}
</style>
